import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-navy-800 text-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center mb-4">
              <span className="text-coral-300 text-[34px] font-serif italic font-semibold">galeriecop</span>
              <span className="text-coral-300 text-xs ml-0.5 mt-1">TM</span>
            </div>
            <p className="text-cream-100/70 text-sm max-w-sm leading-relaxed">
              The original private QR code photo sharing platform &amp; digital guestbook. Because it only happens once.
            </p>
            <div className="flex gap-3 mt-6">
              {[
                { Icon: Instagram, href: "https://instagram.com/galeriecop", label: "Instagram · @galeriecop", tid: "footer-social-instagram" },
                { Icon: Facebook, href: "#", label: "Facebook", tid: "footer-social-facebook" },
                { Icon: Youtube, href: "#", label: "YouTube", tid: "footer-social-youtube" },
                { Icon: Mail, href: "mailto:support@galeriecop.com", label: "Email support", tid: "footer-social-mail" },
              ].map(({ Icon, href, label, tid }) => {
                const isExternal = href.startsWith("http");
                return (
                  <a
                    key={tid}
                    href={href}
                    data-testid={tid}
                    aria-label={label}
                    title={label}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                    className="w-9 h-9 rounded-full border border-cream-100/20 flex items-center justify-center hover:bg-coral-300 hover:border-coral-300 transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="text-coral-300 font-semibold mb-4 text-sm uppercase tracking-wider">Events</h4>
            <ul className="space-y-2.5 text-sm text-cream-100/80">
              <li><Link to="/weddings" className="hover:text-coral-300">Weddings</Link></li>
              <li><Link to="/party" className="hover:text-coral-300">Parties</Link></li>
              <li><Link to="/business" className="hover:text-coral-300">Business</Link></li>
              <li><Link to="/memorials" className="hover:text-coral-300">Memorials</Link></li>
              <li><Link to="/engagements" className="hover:text-coral-300">Engagements</Link></li>
              <li><Link to="/kids-parties" className="hover:text-coral-300">Kids Parties</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-coral-300 font-semibold mb-4 text-sm uppercase tracking-wider">Pricing</h4>
            <ul className="space-y-2.5 text-sm text-cream-100/80">
              <li><Link to="/weddings-pricing" className="hover:text-coral-300">Wedding</Link></li>
              <li><Link to="/engagements-pricing" className="hover:text-coral-300">Engagement</Link></li>
              <li><Link to="/party-pricing" className="hover:text-coral-300">Party</Link></li>
              <li><Link to="/business-pricing" className="hover:text-coral-300">Business</Link></li>
              <li><Link to="/memorials-pricing" className="hover:text-coral-300">Memorial</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-coral-300 font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-2.5 text-sm text-cream-100/80">
              <li><Link to="/our-story" className="hover:text-coral-300">Our Story</Link></li>
              <li><Link to="/how-it-works" className="hover:text-coral-300">How It Works</Link></li>
              <li><Link to="/partners" className="hover:text-coral-300">Vendor Partners</Link></li>
              <li><Link to="/help-center" className="hover:text-coral-300">Help Center</Link></li>
              <li><Link to="/contact" className="hover:text-coral-300">Contact</Link></li>
              <li><Link to="/blog" className="hover:text-coral-300">Blog</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream-100/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-cream-100/60 text-xs">© {new Date().getFullYear()} GALERIECOP. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-cream-100/60 justify-center md:justify-end">
            <Link to="/privacy" className="hover:text-coral-300">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-coral-300">Terms &amp; Conditions</Link>
            <Link to="/cookies" className="hover:text-coral-300">Cookie Policy</Link>
            <Link to="/data-deletion" className="hover:text-coral-300">Data Deletion</Link>
            <Link to="/acceptable-use" className="hover:text-coral-300">Acceptable Use</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("galeriecop:open-cookie-banner"))}
              data-testid="footer-cookie-settings"
              className="hover:text-coral-300"
            >
              Cookie settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
